
export const formStyleConstants = {
    smallField: 'size-4-12',
    isFilled: 'is-filled',
    isSuccess: 'is-success',
    isInvalid: 'is-invalid',
    isOpened: 'is-opened',
    fieldHeaderClassName: 'fieldHeader',
    customFieldClassName: 'customField'
};
